import * as React from 'react';
import toastContext from './context-shape';
import { IWithToastProps } from './Toast';
export { IWithToastProps };
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
export default function withToast(WrappedComponent) {
    class WithToastWrapper extends React.Component {
        render() {
            return <WrappedComponent {...this.props} toast={this.context.toast}/>;
        }
    }
    WithToastWrapper.contextTypes = {
        toast: toastContext
    };
    WithToastWrapper.displayName = `withToast(${getDisplayName(WrappedComponent)})`;
    return WithToastWrapper;
}
